/**
 * @module types/settings/crosstab
 * @description 透视表交叉表结构（存储字段名 `crosstab`）
 *
 * 归一化与 QB 同步逻辑见 `utils/crosstab`。
 */

export type {
  ICrosstabConfig,
  ICrosstabFieldRef,
} from '../../utils/crosstab';

import type { ICrosstabConfig, ICrosstabFieldRef } from '../../utils/crosstab';

const CROSSTAB_EMPTY_ROWS: ICrosstabFieldRef[] = Object.freeze(
  [],
) as ICrosstabFieldRef[];

const CROSSTAB_EMPTY_COLUMNS: ICrosstabFieldRef[] = Object.freeze(
  [],
) as ICrosstabFieldRef[];

/**
 * 未落库时 Schema 缺省（空行列）
 *
 * PivotTable 须配合 `hasStoredCrosstab`：无落库时不应把本默认当作「已持久化配置」。
 *
 * @stable 须与 STRUCTURED_SETTING_DEFAULTS.crosstab 为同一引用语义
 */
export const CROSSTAB_DEFAULT: ICrosstabConfig = Object.freeze({
  rows: CROSSTAB_EMPTY_ROWS,
  columns: CROSSTAB_EMPTY_COLUMNS,
}) as ICrosstabConfig;
